import contextLoadable from '@signal/core/contextFetch/Loadable'
import {
  UserAccountsContext,
  UserDetailsContext
} from '@signal/core/user/Context'
import Component from '@signal/components/CommonPage/Component'
import Skeleton from '@signal/components/CommonPage/Skeleton'
import { CommonPagePropsType } from '@signal/components/CommonPage/types'

export default contextLoadable<CommonPagePropsType>({
  fetchContexts: [UserAccountsContext, UserDetailsContext],
  Component,
  Skeleton
})
